import { render, staticRenderFns } from "./configuration-local-accounting-billable-rate-modal-basic-form.vue?vue&type=template&id=039300c4&"
import script from "./configuration-local-accounting-billable-rate-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-accounting-billable-rate-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports